export enum AdvancedSearchType {
  AddressAdvanced = 'addressAdvanced',
  AddressByPfi = 'addressByPfi',
  Coordinates = 'coordinates',
  CrownDescription = 'crownDescription',
  LotByPlan = 'lotByPlan',
  LotByStreet = 'lotByStreet',
  ParcelBySpi = 'parcelBySpi',
  ParcelByPfi = 'parcelByPfi',
  ParcelByViewPfi = 'parcelByViewPfi',
  PropertyByCouncilNo = 'propertyByCouncilNo',
  PropertyByPfi = 'propertyByPfi',
  PropertyByViewPfi = 'propertyByViewPfi',
  SurveyLabel = 'surveyLabel',
  SurveyMark = 'surveyMark',
}

export const AdvancedSearchMap: Record<
  AdvancedSearchType,
  {
    route: string;
    executeRoute: string;
    paramKeys: string[];
    title: string;
    subTitle?: string;
  }
> = {
  [AdvancedSearchType.AddressAdvanced]: {
    route: 'address-search/advanced',
    executeRoute: 'address-search/advanced',
    paramKeys: ['addrSearchFormData'],
    title: 'Address Search',
    subTitle: 'Advanced',
  },
  [AdvancedSearchType.AddressByPfi]: {
    route: 'address-search/pfi',
    executeRoute: 'address-search/pfi',
    paramKeys: ['addressPfi'],
    title: 'Address Search',
    subTitle: 'PFI',
  },
  [AdvancedSearchType.Coordinates]: {
    route: 'coordinates-search',
    executeRoute: 'coordinates-search',
    paramKeys: ['searchByCoordinatesFormData'],
    title: 'Coordinate Search',
  },
  [AdvancedSearchType.CrownDescription]: {
    route: 'crown-description-search',
    executeRoute: 'crown-description-search',
    paramKeys: ['searchByCrownDescriptionFormData'],
    title: 'Crown Description Search',
  },
  [AdvancedSearchType.LotByPlan]: {
    route: 'lot/plan',
    executeRoute: 'lot/plan/results',
    paramKeys: ['searchLotByPlanFormData'],
    title: 'Lot Search',
    subTitle: 'Plan',
  },
  [AdvancedSearchType.LotByStreet]: {
    route: 'lot/street',
    executeRoute: 'lot/street/results',
    paramKeys: ['searchLotByStreetFormData'],
    title: 'Lot Search',
    subTitle: 'Street',
  },
  [AdvancedSearchType.ParcelBySpi]: {
    route: 'parcel/spi',
    executeRoute: 'parcel/spi/results',
    paramKeys: ['parcelSpi'],
    title: 'Parcel Search',
    subTitle: 'SPI',
  },
  [AdvancedSearchType.ParcelByPfi]: {
    route: 'parcel/pfi',
    executeRoute: 'parcel/pfi',
    paramKeys: ['parcelPfi'],
    title: 'Parcel Search',
    subTitle: 'PFI',
  },
  [AdvancedSearchType.ParcelByViewPfi]: {
    route: 'parcel/view-pfi',
    executeRoute: 'parcel/view-pfi',
    paramKeys: ['parcelViewPfi'],
    title: 'Parcel Search',
    subTitle: 'VIEW PFI',
  },
  [AdvancedSearchType.PropertyByCouncilNo]: {
    route: 'property/council-no',
    executeRoute: 'property/council-no/results',
    paramKeys: ['propertyNumber', 'lgaCode', 'lgaName'],
    title: 'Property Search',
    subTitle: 'Council No',
  },
  [AdvancedSearchType.PropertyByPfi]: {
    route: 'property/pfi',
    executeRoute: 'property/pfi',
    paramKeys: ['propertyPfi'],
    title: 'Property Search',
    subTitle: 'PFI',
  },
  [AdvancedSearchType.PropertyByViewPfi]: {
    route: 'property/view-pfi',
    executeRoute: 'property/view-pfi',
    paramKeys: ['propertyViewPfi'],
    title: 'Property Search',
    subTitle: 'VIEW PFI',
  },
  [AdvancedSearchType.SurveyLabel]: {
    route: 'survey-label',
    executeRoute: 'survey-label/results',
    paramKeys: ['searchSurveyLabelFormData'],
    title: 'Survey Label Search',
  },
  [AdvancedSearchType.SurveyMark]: {
    route: 'survey-mark',
    executeRoute: 'survey-mark/results',
    paramKeys: ['searchSurveyMarkFormData'],
    title: 'Survey Mark Search',
  },
};

export function getSavedSearchFriendlyType(searchType: string): string {
  const mapping = AdvancedSearchMap[searchType as AdvancedSearchType];
  if (!mapping) {
    return searchType;
  }

  return mapping.subTitle
    ? `${mapping.title} ${mapping.subTitle}`
    : mapping.title;
}

export interface SavedAdvancedSearchItem {
  id: string | number;
  search_name: string;
  search_type: string;
  search_criteria: string;
}
